import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { PartsManagementResponse } from '../../../models/parts-management-response.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-parts-management-cost-details',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './parts-management-cost-details.component.html',
  styleUrl: './parts-management-cost-details.component.scss',
})
export class PartsManagementCostDetailsComponent {
  @Input() partsManagementCostDetails!: PartsManagementResponse;
}
